type ReviewSummaryRestaurant = {
  reviewSummary?: string | null;
  reviewSummaryDetails?: string | null;
};

export const REVIEW_SUMMARY_TRUNCATE_LENGTH = 300;

export function hasRestaurantReviewSummary(
  restaurant: ReviewSummaryRestaurant
): restaurant is ReviewSummaryRestaurant & {
  reviewSummary: string;
  reviewSummaryDetails: string;
} {
  return Boolean(restaurant.reviewSummary && restaurant.reviewSummaryDetails);
}

export function truncateReviewSummary(summary: string) {
  if (summary.length <= REVIEW_SUMMARY_TRUNCATE_LENGTH) {
    return summary;
  }

  const truncated = summary.slice(0, REVIEW_SUMMARY_TRUNCATE_LENGTH).trimEnd();
  return `${truncated.replace(/[.,;:!?…]+$/, '')}...`;
}
